import {Routes} from '@angular/router';
import {wyCashRoutes} from './wy.cash/wy.cash.routes';
import {electricityCashRoutes} from './electricity.cash/electricity.cash.routes';
import {gasCashRoutes} from './gas.cash/gas.cash.routes';
import {parkingCashRoutes} from './parking.cash/parking.cash.routes';
import {waterCashRoutes} from './water.cash/water.cash.routes';
import {releaseCashRoutes} from './release.cash/release.cash.routes';
import {giftCashRoutes} from './gift.cash/gift.cash.routes';
import {cashbackCashRoutes} from './cashback.cash/cashback.cash.routes';
import {freeShippingCashRoutes} from './freeshipping.cash/freeshipping.cash.routes';
import {rechargeCashRoutes} from "./recharge.cash/recharge.cash.routes";
import {storereleaseCashRoutes} from "./storerelease.cash/storerelease.cash.routes";
import {partnerCashRoutes} from "./partner.cash/partner.cash.routes";

export const cashManagementRoutes: Routes = [
  {
    path: 'cashManagement',
    loadComponent: () => import('./cash-management.component').then(m => m.CashManagementComponent),
    data: { title: '兑付管理' },
    children: [
      ...wyCashRoutes,
      ...electricityCashRoutes,
      ...gasCashRoutes,
      ...parkingCashRoutes,
      ...waterCashRoutes,
      ...releaseCashRoutes,
      ...giftCashRoutes,
      ...cashbackCashRoutes,
      ...freeShippingCashRoutes,
      ...rechargeCashRoutes,
      ...storereleaseCashRoutes,
      ...partnerCashRoutes
    ]
  }
]
